import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'issues-no-payments-grid-item',
    templateUrl: './issues-no-payments-grid-item.component.html'
})
export class IssuesNoPaymentsGridItemComponent implements OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService
    ) {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {
        this.clientId = this.route.parent.snapshot.params['clientId'];
        if (this.clientId == null || this.clientId == undefined) this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['noPaymentsPage']) {
                    this.page = +queryParams['noPaymentsPage'];
                }
            }));

        this.getData();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    isValidDate(item: any): boolean {
        let date = new Date(item.latestPayment);
        let yearString = date.getFullYear().toString();
        if (yearString === "1") {
            return false;
        } else {
            return true;
        }
    }

    getData() {
        this.issueService.issuePaygGetNoPaymentsPaged(this.clientId, this.page, this.pageSize, this.siteId).then(
            result => {
                this.data = [];
                if (result && result.items.length > 0) {
                    this.dataService.issuesNoPaymentsGridItemComponentResolved.next(result.items.length > 0);
                    this.data = result.items;
                    this.totalPages = result.totalPages
                    this.pageSize = result.pageSize;
                    this.dataService.issuesNoPaymentsGridItemComponentResolved.next(true);
                } else { this.dataService.issuesNoPaymentsGridItemComponentResolved.next(false); } 
            },
            error => {
                this.dataService.issuesNoPaymentsGridItemComponentResolved.next(false);
            }
        );
    }

    onInfoClick() {
        swal({
            title: 'Last payment',
            html: '<p style="text-align: left;">This widget tells you when the last payment was received on a consumer account.</p>\
            <p style="text-align: left;">Consumers who do not make a payment for a long period of time could indicate a welfare issue such as fuel poverty.</p>\
            <p style="text-align: left;">Consumer top-up patterns change seasonally. You should expect consumers to top-up less during the warmer months.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
